import styled from "styled-components";

const Wrapper = styled.div`
  background: #a80000;
  color: white;
  padding: 1rem;
  text-align: center;
  margin-bottom: 1.5rem;
`;

interface ErrorProps {
  text: string | undefined;
}

const Error = (props: ErrorProps) => {
  const { text } = props;

  if (!text) return null;

  return <Wrapper>{text}</Wrapper>;
};

export default Error;
